import type { AccountState } from '../types';

export function isLoggedIn(account: AccountState) {
  return !!(account && account.data && account.data.id);
}

export function accountId(account: AccountState) {
  return isLoggedIn(account) ? account.data.id : '';
}

export function accountDisplayName(account: AccountState) {
  if (!isLoggedIn(account)) {
    return '';
  }

  return account.data.displayName.length > 0
    ? account.data.displayName
    : accountEmail(account);
}

export function accountEmail(account: AccountState) {
  return isLoggedIn(account) ? account.data.email : '';
}

export function accountHasCart(account: AccountState) {
  return isLoggedIn(account) && account.data.currentCartId >= 0;
}

export function accountCartId(account: AccountState) {
  return accountHasCart(account) ? account.data.currentCartId : undefined;
}

const AccountSelector = {
  isLoggedIn,
  accountId,
  accountDisplayName,
  accountEmail,
  accountHasCart,
  accountCartId,
};

export default AccountSelector;
